module.exports = __webpack_public_path__ + "static/media/optima-seguros-plus.bf06aff2.svg";